import { useMyPermissions } from './useMyPermissions'
import type { ConfiguredLanguage, MyPermissions } from './permissionHelpers'

export type { ConfiguredLanguage }

export function deriveAppLocale(perms?: MyPermissions): {
  locale: string | null
  languages: ConfiguredLanguage[]
  defaultCode?: string
} {
  if (!perms) {
    return { locale: null, languages: [], defaultCode: undefined }
  }
  const languages = perms.languages ?? []
  return {
    locale: perms.locale ?? null,
    languages,
    defaultCode: languages.find((l) => l.isDefault)?.code,
  }
}

export function useAppLocale(): {
  locale: string | null
  languages: ConfiguredLanguage[]
  defaultCode?: string
  loading: boolean
} {
  const { perms, loading } = useMyPermissions()
  return { ...deriveAppLocale(perms), loading }
}
